import { Alert, Button, Form, Space, Switch } from "antd";
import PageContentWrapper from "../../components/PageContentWrapper";
import { getConfiguration, updateConfiguration } from "../../appRedux/actions/Configuration";
import { useEffect, useState } from "react";
import { get2FA, set2FA } from "../../appRedux/actions";
import { baseRequest } from "../../util/Api";
import CircularProgress from "../../components/CircularProgress";
import { WhatsAppOutlined } from "@ant-design/icons";

export default function Edit2FAPage() {
  const [form] = Form.useForm()
  const [image, setImage] = useState(null)
  const [scanned, setScanned] = useState(null);

  useEffect(() => {
    get2FA()
      .then(data => {
        const twofaEnabled = data.twofa_enabled ? data.twofa_enabled : false;
        const twofaScanned = data.twofa_scanned ? data.twofa_scanned : false;
        form.setFieldsValue({
          twofa_enabled: twofaEnabled
        })
        setScanned(twofaScanned)
        if (twofaScanned)
          setImage('')
        else
          getQRImage()
      })
  }, [])

  async function getQRImage() {
    const { qr } = await baseRequest("get", `users/2fa-secret`);
    setImage(qr)
  }

  return (
    <PageContentWrapper title="Edit Two-Factor Authentication">
      {scanned ? (
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            twofa_enabled: false,
          }}
          style={{ padding: 10 }}
          onFinish={() => { }}
          onValuesChange={(changedValues) => {
            for (const [key, value] of Object.entries(changedValues)) {
              set2FA({
                twofa_enabled: value,
                twofa_scanned: scanned,
              })
              if (value)
                getQRImage()
            }
          }}
        >
          <Form.Item
            name="twofa_enabled"
            label="Two-Factor Authentication Aktif?"
            valuePropName="checked"
          >
            <Switch checkedChildren="Ya" unCheckedChildren="Tidak" />
          </Form.Item>
        </Form>
      ) : (
        <></>
      )}
      {image == null && (
        <CircularProgress />
      )}
      {(image == '') && <>
        <Alert
          message="Sudah Pindai QR Code"
          description="Anda sudah melakukan pindai qrcode. Jika ingin me-reset secret Microsoft Authenticator silahkan hubungi admin melalui whatsapp 0819-0819-1001"
          type="info"
          closable={false}
          action={
            <a href="https://wa.me/6281908191001?text=Saya%20ada%20kendala%20scan%20TwoFA" target="_blank"
              className="ant-btn ant-btn-sm ant-btn-info"
              style={{ marginTop: "auto", marginBottom: "auto" }}>
              <WhatsAppOutlined /> Whatsapp
            </a>
          }
        />
      </>}
      {(image != '') && (
        <Space
          direction="vertical"
          align="center"
          style={{
            display: 'flex',
            width: '24rem',
          }}
        >
          <Space>
            <span>
              {/* Silahkan pindai qrcode dibawah ini menggunakan aplikasi <b>Microsoft Authenticator</b>. */}
              Silahkan pindai qrcode dibawah ini menggunakan aplikasi <b>Microsoft Authenticator</b> lalu klik tombol "Sudah" di bawah.
              <br/>
              Aplikasi dapat diunduh melalui
              &nbsp;<a target="_blank" href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=id">PlayStore</a>
              &nbsp;dan&nbsp;
              <a target="_blank" href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458">App Store</a>.
              Jika ada kendala, silahkan hubungi admin melalui whatsapp <a href="https://wa.me/6281908191001?text=Saya%20ada%20kendala%20TwoFA" target="_blank">081908191001</a>
            </span>
          </Space>
          <img src={`data:image/png;base64,${image}`} />
        </Space>
      )}
      {(scanned === false) &&
        <Alert
          message="Sudah Pindai?"
          description="Apakah anda sudah memindai kode qr dibawah ini?"
          type="info"
          action={
            <Space direction="vertical">
              <Button size="small" type="primary" onClick={() => {
                set2FA({
                  twofa_enabled: form.getFieldValue('twofa_enabled'),
                  twofa_scanned: true,
                })
                setImage('')
                setScanned(true)
              }}>
                Sudah
              </Button>
            </Space>
          }
          closable={false}
        />
      }
    </PageContentWrapper>
  );
}